import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EncrDecrService } from './encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class BookmarkService {

  bookmarkEventAPIuri: string = 'event/bookmark';
  myBookmarkEventsAPIuri: string = 'event/bookmark/events';

  constructor(private http: HttpClient,
    private EncDecService: EncrDecrService) { }

  bookmarkEvent(data) {
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + this.bookmarkEventAPIuri, data, { headers: headers_object }).toPromise();
  }

  getMyBookmarkEvents() {
    const user = JSON.parse(this.EncDecService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get(environment.apiURI + this.myBookmarkEventsAPIuri, { headers: headers_object }).toPromise();
  }
}
